(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.directive('thirdPartyAppDropdown', ['$templateCache', '$compile', '$state', '$window', 'ThirdPartyAppService', 'SharedAgendaBroadcast', ThirdPartyAppDropdownDirectiveFn]);

    // row directive for third party app dropdown
    function ThirdPartyAppDropdownDirectiveFn($templateCache, $compile, $state, $window, ThirdPartyAppService, SharedAgendaBroadcast) {
        var template = '/app/settings/administration/modules/thirdpartyapps/templates/third-party-app-dropdown.template.html';

        var directive = {
            link: link,
            
            restrict: 'A',
            templateUrl: template,
            scope: {}
        };

        return directive;

        function link(scope, element) {
            
            // list of apps
            scope.apps = [];

            // get the template cached used to build this directive
            var cachedTemplate = $templateCache.get(template);

            activate();

            // activate
            function activate() {
                fetch();

                listen();
            } // activate

            // fetch
            function fetch() {
                ThirdPartyAppService.getByUser().then(function (result) {
                    scope.apps = result;
                    makeElement();
                });
            }

            // listen
            function listen() {
                // listen on agneda change
                var listener = scope.$on(SharedAgendaBroadcast.AgendaChanged, function () {
                    fetch();
                });

                // destroy
                scope.$on("$destroy", function () {
                    listener();
                    listener = null;
                });

            }

            // refactor drop down menu info screen
            function makeElement() {
                // empty current element
                element.empty();
                // are there any items
                if (scope.apps.length === 0) { return; }
                // compile template
                var el = $compile(cachedTemplate)(scope);
                // append compiled template file
                element.append(el);
            }

            scope.openExternalApp = function(url)
            {
                try {
                    cmdSwapTabs(url);
                }catch(err)
                {
                    $window.open(url, "_blank");
                }
            }

            //// open in modal
            //scope.show = function (app) {
            //    $state.go('Home.ThirdPartyApp', { url: app.url });
            //};


        } // link
    }

})();